import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';

import { DealerStore } from '../../stores/dealer.store';
import { CaseCreationStore } from '../../stores/v2/case-creation.store';
import { VehicleService } from '../vehicle.service';
import { UserStore } from '../../stores/user.store';
import { NeededActionsVinRequest } from 'src/app/shared/models/case-creation/vehicle.model';

@Injectable()
export class NeededActionsService {
  private readonly caseCreationStore = inject(CaseCreationStore);
  private readonly vehicleService = inject(VehicleService);
  private readonly dealerStore = inject(DealerStore);
  private readonly userStore = inject(UserStore);

  loadSelectedVinsNeededActions(destroy: DestroyRef): void {
    const selectedDealer = this.dealerStore.selectedDealer();
    const vins = this.caseCreationStore.getPreviousStepSelectedVins();

    const vinRequests: NeededActionsVinRequest[] = vins.map((vin) => ({
      vin,
      validationCampaign: this.caseCreationStore.getVinValidationCampaign(vin),
    }));

    this.vehicleService
      .getMultipleNeededActions(
        vinRequests,
        this.caseCreationStore.caseType(),
        selectedDealer,
        this.dealerStore.getSelectedDealerMarketCode(),
        this.userStore.userPreferredLanguage() || 'en'
      )
      .pipe(
        takeUntilDestroyed(destroy),
        catchError(() => {
          return of([]);
        })
      )
      .subscribe({
        next: (neededActions) => {
          this.caseCreationStore.setNeededActionsInformation(neededActions);
          this.caseCreationStore.setCaseLanguage(this.userStore.userPreferredLanguage() || 'en');
        },
      });
  }
}
